import { ASSISTANT_SPECIALTIES, ASSISTANT_GLOBAL_RULES } from './playbook/shared';
import brandGuide, { STAGE_KEY as BRAND_KEY, STAGE_CONFIG as BRAND_CONFIG } from './playbook/brand';
import attractionGuide, { STAGE_KEY as ATTRACTION_KEY, STAGE_CONFIG as ATTRACTION_CONFIG } from './playbook/attraction';
import nurturingGuide, { STAGE_KEY as NURTURING_KEY, STAGE_CONFIG as NURTURING_CONFIG } from './playbook/nurturing';
import conversionGuide, { STAGE_KEY as CONVERSION_KEY, STAGE_CONFIG as CONVERSION_CONFIG } from './playbook/conversion';
import scaleGuide, { STAGE_KEY as SCALE_KEY, STAGE_CONFIG as SCALE_CONFIG } from './playbook/scale';

export const STAGE_KEYS = {
  BRAND: BRAND_KEY,
  ATTRACTION: ATTRACTION_KEY,
  NURTURING: NURTURING_KEY,
  CONVERSION: CONVERSION_KEY,
  SCALE: SCALE_KEY,
};

export const CENTRAL_STAGE_CONFIG = {
  [BRAND_KEY]: BRAND_CONFIG,
  [ATTRACTION_KEY]: ATTRACTION_CONFIG,
  [NURTURING_KEY]: NURTURING_CONFIG,
  [CONVERSION_KEY]: CONVERSION_CONFIG,
  [SCALE_KEY]: SCALE_CONFIG,
};

export const ASSISTANT_PROCESS_GUIDES = {
  [BRAND_KEY]: brandGuide,
  [ATTRACTION_KEY]: attractionGuide,
  [NURTURING_KEY]: nurturingGuide,
  [CONVERSION_KEY]: conversionGuide,
  [SCALE_KEY]: scaleGuide,
};

export const buildAssistantKnowledgePrompt = (stageKey) => {
  const process = ASSISTANT_PROCESS_GUIDES[stageKey] || ASSISTANT_PROCESS_GUIDES.brand;

  return `
--- CONTEXTO DE ETAPA ---
ID ETAPA ACTUAL: ${stageKey}
ROL: ${process.role}

REGLAS ESPECIFICAS DE ESTA ETAPA:
${ASSISTANT_GLOBAL_RULES.map((item) => `- ${item}`).join('\n')}

DETECTAR CUANDO:
${process.detectWhen.map((item) => `  - ${item}`).join('\n')}
---
`.trim();
};

const assistantPlaybook = {
  ASSISTANT_SPECIALTIES,
  ASSISTANT_GLOBAL_RULES,
  ASSISTANT_PROCESS_GUIDES,
  buildAssistantKnowledgePrompt,
};

export default assistantPlaybook;
